import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/rastra-bharat-new/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/rastra-bharat-new/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/rastra-bharat-new/src/app/components/Footer/Footer.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/rastra-bharat-new/src/app/components/Layout/ShowMoreNewsWrapper.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/rastra-bharat-new/src/app/components/Navbar/Navbar.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/rastra-bharat-new/src/app/components/Posts/PostDetails/MoreNews.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/rastra-bharat-new/src/app/lib/SchemaScript.js");
